import React from 'react'
import './footer.css'

const footer = () => {
    return <div className="footer"></div>
}

export default footer
